export enum StoresTableSortProps {
  ID = 'id',
  NAME = 'name',
  EMAIL = 'email',
  RATINGS = 'rating'
  // TOTAL_VISITORS = 'totalVisitors',
  // SOLD = 'sold',
  // TOTAL_REVENUE = 'totalRevenue',
  // COUNTRY = 'country'
}

export interface StoresTableSearchProps {
  id: number
  name: string
  email: string
  minRating: number
  maxRating: number
  minSold: number
  maxSold: number
  minRevenue: number
  maxRevenue: number
  country: string,
  status: string,
}
